import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class RoleService {
  baseUrl = 'role';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = (includeOrganizationAdmin) => BaseService.get({ url: `${this.baseUrl}/get-list/${includeOrganizationAdmin}` });
  getFunctionRightList = () => BaseService.get({ url: `${this.baseUrl}/get-function-rights-list` });
  getUserList = (roleId) => BaseService.get({ url: `${this.baseUrl}/get-user-list/${roleId}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (role) => BaseService.post({ url: `${this.baseUrl}/save`, data: role });
}

export default new RoleService()
